// extracted by css-extract-rspack-plugin
export default {"cls1":"AutoCompleteResults-cls1_TKs","cls2":"AutoCompleteResults-cls2_78n AutoCompleteResults-cls1_TKs"};